import React, { ReactNode } from 'react'
import { useDispatch } from 'react-redux'
import {
  QuickbetBetButtonStyled,
  QuickbetButtonMoneyStyled,
  QuickbetButtonStyled,
} from './QuickbetButton.styles'
import { BusyIndicator } from '../BusyIndicator/BusyIndicator'
import { appHistory } from '@core/Utils/routing/history'
import { ACCOUNT_ACTIVITY_PENDING_ROUTE } from '@core/Areas/AccountActivity/constants'
import { QUICKBET_MODAL_ID } from '../../constants'
import { showLogin } from '@core/Areas/Login/helpers/showLogin'
import { closeModal } from '@core/Components/Modal'
import { RemoveCampaignButtonStyled } from '../Campaigns/Campaigns.styles'
import { Icon } from '@mobi/component-library/Common/Icon'
import { ButtonTypes } from '@mobi/component-library/Common/Buttons'

export const LoginButton = () => (
  <QuickbetButtonStyled type='button' onClick={() => showLogin()} data-tid-quickbet-login-button>
    Log in to place bet
  </QuickbetButtonStyled>
)

export const BettingButton: React.FC<{
  onClick: () => void
  betCost: number
  isDisabled: boolean
  label: string
}> = ({ onClick, label, betCost, isDisabled }) => (
  <QuickbetBetButtonStyled onClick={onClick} disabled={isDisabled} data-tid-quickbet-betting-btn>
    {label} <QuickbetButtonMoneyStyled amount={betCost} />
  </QuickbetBetButtonStyled>
)

export const BusyButton = () => (
  <QuickbetButtonStyled disabled={true}>
    <BusyIndicator />
  </QuickbetButtonStyled>
)

export const EditBetButton: React.FC<{
  isDisabled?: boolean
  onClick: VoidFunction
}> = ({ isDisabled = false, onClick }) => (
  <QuickbetButtonStyled
    color='secondary'
    type='button'
    role='button'
    onClick={onClick}
    disabled={isDisabled}
    data-tid-quickbet-edit-bet-btn
  >
    Edit your Bet
  </QuickbetButtonStyled>
)

export const PendingBetsButton = () => {
  const dispatch = useDispatch()

  const pendingBetsButtonClick = () => {
    dispatch(closeModal({ id: QUICKBET_MODAL_ID }))
    appHistory.push('/' + ACCOUNT_ACTIVITY_PENDING_ROUTE)
  }

  return (
    <QuickbetButtonStyled
      color='secondary'
      type='button'
      onClick={pendingBetsButtonClick}
      data-tid-quickbet-pending-bets-btn
    >
      Pending Bets
    </QuickbetButtonStyled>
  )
}

export const NextEventButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <QuickbetButtonStyled
    color='secondary'
    type='button'
    onClick={onClick}
    data-tid-quickbet-nextevents-btn
  >
    Next Events
  </QuickbetButtonStyled>
)

export const KeepBetsButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <QuickbetButtonStyled type='button' color='secondary' onClick={onClick}>
    Keep Bets
  </QuickbetButtonStyled>
)

export const CloseButton = () => {
  const dispatch = useDispatch()
  return (
    <QuickbetButtonStyled
      type='button'
      onClick={() => dispatch(closeModal({ id: QUICKBET_MODAL_ID }))}
      data-tid-quickbet-close-btn
    >
      Close
    </QuickbetButtonStyled>
  )
}

export const DepositButton: React.FC<{
  color?: Extract<keyof ButtonTypes, 'primary' | 'secondary'>
  children: ReactNode
  onClick?: () => void
  isDisabled?: boolean
}> = ({ isDisabled = false, children, color = 'primary', onClick }) => (
  <QuickbetButtonStyled
    color={color}
    type='button'
    role='button'
    onClick={onClick}
    disabled={isDisabled}
    data-tid-quickbet-deposit-btn
  >
    {children}
  </QuickbetButtonStyled>
)

interface BetslipButtonProps {
  onClick: () => void
  isDisabled: boolean
}

export const RemoveCampaignButtonComponent = ({ onClick, isDisabled }: BetslipButtonProps) => {
  return (
    <RemoveCampaignButtonStyled onClick={onClick} disabled={isDisabled}>
      <Icon type='minusCircled' title='Remove' size='1.8rem' />
    </RemoveCampaignButtonStyled>
  )
}
